import {useEffect} from 'react'

import {PDF_SCROLLBAR_WIDTH} from '#/lib/document/pdfFit'

export const PDF_SKELETON_CLASS = 'pdf-carousel-skeleton'
export const PDF_SCROLL_AREA_CLASS = 'pdf-carousel-scroll-area'

const STYLE_ID = 'pdf-carousel-styles'
const CSS = `
.${PDF_SKELETON_CLASS} {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    rgba(0, 0, 0, 0.04) 30%,
    rgba(0, 0, 0, 0.09) 50%,
    rgba(0, 0, 0, 0.04) 70%
  );
  background-size: 300% 100%;
  animation: pdf-carousel-shimmer 1.4s ease-in-out infinite;
}
[data-color-scheme="dark"] .${PDF_SKELETON_CLASS} {
  background: linear-gradient(
    100deg,
    rgba(255, 255, 255, 0.05) 30%,
    rgba(255, 255, 255, 0.11) 50%,
    rgba(255, 255, 255, 0.05) 70%
  );
  background-size: 300% 100%;
}
@keyframes pdf-carousel-shimmer {
  0% { background-position: 120% 0; }
  100% { background-position: -20% 0; }
}
.${PDF_SCROLL_AREA_CLASS} {
  scrollbar-width: thin;
}
.${PDF_SCROLL_AREA_CLASS}::-webkit-scrollbar {
  width: ${PDF_SCROLLBAR_WIDTH}px;
  height: ${PDF_SCROLLBAR_WIDTH}px;
}
.${PDF_SCROLL_AREA_CLASS}::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.45);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
@media (prefers-reduced-motion: reduce) {
  .${PDF_SKELETON_CLASS} {
    animation: none;
  }
}
`

/**
 * Injects the carousel's stylesheet once per page. Done through the DOM rather
 * than a `style` element in the tree so a feed full of documents only ships
 * one copy of the CSS.
 */
export function usePdfStyles() {
  useEffect(() => {
    if (typeof document === 'undefined') return
    if (document.getElementById(STYLE_ID)) return
    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = CSS
    document.head.appendChild(style)
  }, [])
}
